class UpsellPopup extends HTMLElement{
  constructor(){
    super();
    this.updater()
  }
  updater(){
    var mainObj = this;
    this.updateIt();
    this.querySelector('.GtButtonCTA').addEventListener('click', this.popup.bind(this));
    this.querySelector('.ResetHeader').addEventListener('click', this.close.bind(this));
    this.querySelector('.back-to-Allproducts').addEventListener('click', this.back.bind(this));
    const ProductSwapping = this.querySelectorAll('.ProductTypes li');
    for(let i=0; i<=ProductSwapping.length; i++){ if(ProductSwapping[i]){ ProductSwapping[i].addEventListener('click', this.ProductSwappingFn.bind(this));} }     
    this.addToCart();
    const SelectorCheck=this.querySelectorAll('.GtSetVariantLbl');
    for(let i=0; i<=SelectorCheck.length; i++){ if(SelectorCheck[i]){ SelectorCheck[i].addEventListener('click', this.dropdown.bind(this));} }
    const productCheck=this.querySelectorAll('.GtsetOnboarding');
    for(let i=0; i<=productCheck.length; i++){ if(productCheck[i]){ productCheck[i].addEventListener('click', this.nextStage.bind(this));} }
  }
  updateIt(){
    var dataVal_one='',dataVal_two='',dataVal_three='',mergerMake='',replacer='',key_id=[];
    fetch('/cart.js').then(response => response.json()).then(cart => {
      cart.items.forEach(function(item,index){
        let show_getset = false, isGetSetItem = item.properties['_get_set'], getset_id = item.properties['_getset_id'];
        if (!isGetSetItem && !getset_id) {
          show_getset = true;
        }
        if (!isGetSetItem && getset_id) {
          let added = cart.items.filter(i => i.properties['_getset_id'] == getset_id).length == 2;
          show_getset = !added;
        }
        document.querySelectorAll(`.CartItemsloop__Wp[data-line_index0="${ index }"]`).forEach(($cartItem) => {
          let $cartUpsellItem = $cartItem.querySelector('upsell-popup');
          if ($cartUpsellItem) {
            $cartUpsellItem.classList.toggle('hide', !show_getset);
          }
        });
      })
    })
    this.querySelectorAll('.GtSetVariantItems li').forEach(function(event,key,val){
      if(event.hasAttribute('selected')){
        var valueUpdate = event.getAttribute('value');
        event.closest('ul').setAttribute('data-value',valueUpdate)
      }
    })
    this.querySelectorAll('.GtsetLooperWrap').forEach(function(evt,k,v){
      evt.querySelectorAll('.GtSetVariantItems').forEach(function(event,key,val){
        if(key == 0){dataVal_one = event.dataset.value}
        if(key == 1){dataVal_two = event.dataset.value}
        if(key == 2){dataVal_three = event.dataset.value}
        mergerMake=dataVal_one+' / '+dataVal_two+' / '+dataVal_three, replacer = mergerMake.replace('null',''), replacer = replacer.trim(), replacer = replacer.slice(0, -1);
      })
    })
    this.querySelectorAll('.GtSetVariantLblMn').forEach( (event,index) =>{
      event.addEventListener('click', (event)=>{
        event.target.parentNode.closest('.MainWpXtYupiy').classList.toggle('opened');
      })
    }) 
    // this.variantMatch(replacer)
  }
  ProductSwappingFn(target){
     target.preventDefault();
     event.target.parentNode.closest('.MainWpXtYupiy').classList.remove('opened');
     this.CurrentOne = event.target.getAttribute('upsellidget');
      this.querySelectorAll('.GtsetLooperWrap').forEach((event)=>{
      this.NeedThis = event.getAttribute('upsell-product-id');
      this.NeedThis == this.CurrentOne ? ( this.querySelectorAll('.GtsetLooperWrap').forEach((dt)=>{ dt.classList.remove('is-selected') }),
                                             this.querySelector(`[upsell-product-id="${this.CurrentOne}"]`).classList.add('is-selected'),
                                             this.querySelector('.inner_upsell_enable').setAttribute('current-upsell-id',this.CurrentOne)
                                           ) :  ( console.log('warn') )
      })    
     
  }
  popup(target){
    target.preventDefault();
    var targetLink = target.srcElement.hash;
    const toggler=this.querySelector('.GtsetWrapper').hasAttribute('popup-open') ? 
          this.querySelector('.GtsetWrapper').removeAttribute('popup-open') : 
          this.querySelector('.GtsetWrapper').setAttribute('popup-open','')
  }
  close(target){
    target.preventDefault();
    this.querySelector('.GtsetWrapper').removeAttribute('popup-open');
  }
  back(event){
    event.preventDefault();
    (this.querySelectorAll('.GtsetLooperWrap').forEach(function(event,key,value){
        event.classList.remove('is-selected')
      }),
      this.querySelector('.GtsetItemsWrapp').classList.remove('inner_upsell_enable'),
      event.target.classList.add('hide'),
      this.querySelector('.ResetHeader').classList.remove('hide')
    );
  }
  dropdown(event){
    event.preventDefault();
    const toggle = event.target.closest('.GTsetVrntWrpr').classList.contains('toggle-dropdown') ? 
                   event.target.closest('.GTsetVrntWrpr').classList.remove('toggle-dropdown') :
                   event.target.closest('.GTsetVrntWrpr').classList.add('toggle-dropdown');
    const variantCheck = this.querySelectorAll('.GtsetLooperWrap.is-selected .GtSetVariantItems li');
    for(let i=0; i<=variantCheck.length; i++){ if(variantCheck[i]){ variantCheck[i].addEventListener('click', this.variantSelect.bind(this));} }
  }
  variantSelect(event){
    event.preventDefault();
    if(event.target.nodeName != 'SPAN'){
      event.target.setAttribute('selected','selected'); var optVal = event.target.getAttribute('value'),value_one ='',value_two='',value_three='',mergerMake='',striper='',replacer=''; 
      var node = event.target.closest('ul').firstChild; event.target.closest('ul').setAttribute('data-value',optVal);
      while(node){ if(node !== event.target && node.nodeType === Node.ELEMENT_NODE ) node.removeAttribute('selected','selected'); node = node.nextElementSibling || node.nextSibling; }
      event.target.parentNode.closest('.GtSetVarInputWrap').getAttribute('data-handle') == 'size' ? event.target.parentNode.closest('.GTsetVrntWrpr').classList.remove('toggle-dropdown') : event.target.parentNode.closest('.GTsetVrntWrpr').classList.remove('toggle-dropdown')
      event.target.parentNode.closest('.GTsetVrntWrpr').firstChild.nextElementSibling.firstChild.nextElementSibling.innerHTML =  event.target.getAttribute('value');
      
      event.target.closest('.makeItVariantVised').querySelectorAll('.GtSetVariantItems').forEach(function(event,key,val){
        if(key==0){ value_one = event.getAttribute('data-value') }
        if(key==1){ value_two = event.getAttribute('data-value') }
        if(key==2){ value_three = event.getAttribute('data-value') }
        mergerMake=value_one+' / '+value_two+' / '+value_three;
        // mergerMake.includes('null') ? console.log('not-selected') : replacer = mergerMake.replace('null',''), replacer = replacer.trim(), striper = replacer.slice(0, -1);
      })
      
      mergerMake.includes('null') ? console.log('not-selected') : replacer = mergerMake.replace('null',''), replacer = replacer.trim(), striper = replacer.slice(0, -1);
      striper.trim() == '' ? console.log('nothing') : this.variantMatch(striper);

      
    }else if( event.target.nodeName == 'SPAN' ){
      event.target.parentNode.setAttribute('selected','selected'); var optVal = event.target.parentNode.getAttribute('value'),value_one ='',value_two='',value_three='',mergerMake='',striper='',replacer=''; 
      var node = event.target.parentNode.closest('ul').firstChild; event.target.parentNode.closest('ul').setAttribute('data-value',optVal);
      while(node){ if(node !== event.target.parentNode && node.nodeType === Node.ELEMENT_NODE ) node.removeAttribute('selected','selected'); node = node.nextElementSibling || node.nextSibling; }
      event.target.parentNode.closest('.GtSetVarInputWrap').getAttribute('data-handle') == 'size' ? event.target.parentNode.closest('.GTsetVrntWrpr').classList.remove('toggle-dropdown') : event.target.parentNode.closest('.GTsetVrntWrpr').classList.remove('toggle-dropdown')      
      event.target.parentNode.closest('.GTsetVrntWrpr').firstChild.nextElementSibling.firstChild.nextElementSibling.innerHTML =  event.target.parentNode.getAttribute('value');
      event.target.parentNode.closest('.makeItVariantVised').querySelectorAll('.GtSetVariantItems').forEach(function(event,key,val){
        if(key==0){ value_one = event.getAttribute('data-value') }
        if(key==1){ value_two = event.getAttribute('data-value') }
        if(key==2){ value_three = event.getAttribute('data-value') }
        mergerMake=value_one+' / '+value_two+' / '+value_three;
        // mergerMake.includes('null') ? console.log('not-selected') : replacer = mergerMake.replace('null',''), replacer = replacer.trim(), striper = replacer.slice(0, -1); 
      })
      mergerMake.includes('null') ? console.log('not-selected') : replacer = mergerMake.replace('null',''), replacer = replacer.trim(), striper = replacer.slice(0, -1);
      striper.trim() == '' ? console.log('nothing') : this.variantMatch(striper);     
    }
  }
  variantMatch(value){
    var featured_media='',not_available='',AcceptableSize='',idCap='';value=value.trim()
    this.querySelectorAll('.hiddenSelectorVariant option').forEach(function(event,key,val){
      var variant = event.getAttribute('option-name'), media=event.getAttribute('media'), status=event.getAttribute('status'), vId=event.value;
      const matched = value == variant ? 
        (event.setAttribute('selected','selected'),
         event.closest('select').setAttribute('featured_media',media),
         event.closest('select').setAttribute('current_status',status),
         event.closest('select').setAttribute('current_id',vId)
        ) : 
        (event.removeAttribute('selected'));
    })
    this.querySelectorAll('.GtsetLooperWrap').forEach(function(event,key,val){
      if(event.classList.contains('is-selected')){
        event.querySelectorAll('.hiddenSelectorVariant').forEach(function(evt,k,v){
          featured_media = evt.getAttribute('featured_media'), not_available=evt.getAttribute('current_status'), idCap=evt.getAttribute('current_id');
          event.querySelector('.GtMTPdMedia').firstChild.setAttribute('src',featured_media),
          event.querySelector('.GtMTPdMedia').firstChild.setAttribute('srcset',featured_media),
          event.querySelector('button[type="submit"]').setAttribute('current_id',idCap)

          Object.is(event.querySelector('[data-handle="size"] .GtSetVariantItems li[selected]'), null) ?
            ( event.querySelector('button[type="submit"]').setAttribute('disabled','') )
            :
          (not_available == 'false' ? 
                (event.querySelector('button[type="submit"]').setAttribute('disabled',''),event.querySelector('[data-add-to-cart-text]').innerHTML = 'Out of Stock') : 
                (event.querySelector('button[type="submit"]').removeAttribute('disabled'),event.querySelector('[data-add-to-cart-text]').innerHTML = 'Add To Cart')
           )

        })
      }
    })
  }
  addToCart(){
    var GETSETHANDLE = document.querySelectorAll('[GETSETJSHANDLE]'), key_id=[]; 
    document.querySelectorAll('.cart__item').forEach((item) =>{ key_id.push(item.dataset.id); });
    if(GETSETHANDLE.length > 0){
      GETSETHANDLE.forEach(function(getset){
        getset.addEventListener('click',function(e){
          e.preventDefault();
          var trigger_key = this.closest('.cart__item--upsell').querySelector('.GTsetContainer').getAttribute('data-trigger_key'), 
              line_quantity= this.closest('.cart__item--upsell').querySelector('.GTsetContainer').getAttribute('data-line_quantity'),
              line_properties = this.closest('.cart__item--upsell').querySelector('.GTsetContainer').getAttribute('data-line_properties'), 
              finalBraPropMN ={};
          let lineItemObj, itemsToAdd, variant_id = this.getAttribute('current_id'), timestamp = Date.now();
          let properties = {
            '_get_set': true,
            '_getset_id': timestamp,
            '_CountryEnabled':'USA'
          };
          var BraLinePropArray = line_properties.split(',');
          BraLinePropArray.forEach(function(property){
            var firstPart = property.split('|')[0].trim(), secondPart = property.split('|')[1].trim();
            finalBraPropMN[firstPart] = secondPart;
          })
      
          finalBraPropMN['_getset_id'] = timestamp;
            
          if ( document.body.getAttribute('CountryEnabled') == null ){
           lineItemObj = {id: trigger_key, quantity : line_quantity};    
          }else{
           lineItemObj = {id: trigger_key ,quantity : line_quantity ,properties: finalBraPropMN};
          } 
          return fetch('/cart/change.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(lineItemObj)
          })
          .then(() => {
            var line_key = this.getAttribute('line_key');
            if ( document.body.getAttribute('CountryEnabled') == null ){ 
              itemsToAdd = [{id: variant_id,quantity: 1}];
            }else{
              itemsToAdd = [{id: variant_id,quantity: 1, properties: properties}];          
            }
            fetch('/cart/add.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({ items: itemsToAdd })
            })
            .then((res) => res.json()).then((res) => {
              document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
                bubbles: true
              }));
               document.dispatchEvent(new CustomEvent('cart:updated'));  
            })
            .catch(console.error);
            if(key_id.includes(line_key)){
              sessionStorage.setItem("ItemKey-"+line_key+"", line_key);
              // document.querySelector('.drawer__inner').setAttribute('current_upsell',line_key)
              document.querySelector('[data-line_id="'+sessionStorage.getItem("ItemKey-"+line_key+"")+'"]').style.display ='none'
            }
          });
        })
      })
    }
  }
  nextStage(event){
    event.preventDefault();
    
    if(this.querySelector('.GtsetWrapper').hasAttribute('popup-open'))
    var upsellId=event.target.closest('.GtsetLooperWrap').getAttribute('upsell-product-id');
    const isSelected=!event.target.closest('.GtsetLooperWrap').classList.contains('is-selected') ? 
          (event.target.closest('.GtsetLooperWrap').classList.add('is-selected'), 
           event.target.closest('.GtsetLooperWrap').parentNode.setAttribute('current-upsell-id',upsellId),
           event.target.closest('.GtsetLooperWrap').parentNode.classList.add('inner_upsell_enable'),
           this.querySelector('.ResetHeader').classList.add('hide'),
           this.querySelector('.back-to-Allproducts').classList.remove('hide')
          ) : 
          console.log('Class Already Exists');
  }
}
customElements.define('upsell-popup',UpsellPopup)